var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"icon-chip",class:_vm.contentClass,attrs:{"data-testid":_vm.dataTestid}},[_c('div',{staticClass:"icon",style:({
			'min-width': `${_vm.sizeInPx}px`,
			'min-height': `${_vm.sizeInPx}px`,
			'max-width': `${_vm.sizeInPx}px`,
			'max-height': `${_vm.sizeInPx}px`,
			padding: `${(_vm.sizeInPx / 5)}px`
		})},[_c('img',{attrs:{"src":_vm.icon}})]),(_vm.withContent)?_c('div',{staticClass:"content"},[_c('h3',[_vm._t("title")],2),_c('p',[_vm._t("sub-text")],2)]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }